/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
import Scrollbars from 'react-custom-scrollbars';
import queryString from 'query-string';
import { createSanitizedInnerHTML } from '../../../../shared/utils/htmlSanitizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames'
import {
    Alert,
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap';
import { Store } from '../../../../store';
import { AuthAPI, MyPergamumAPI, PessoaAPI, ResourcesAPI, ParametrosAPI } from '../../../../shared/http-requests';
import {
    ModalConstructor,
    SpinnerConstructor,
    Footer,
} from '../../../../shared/components';
import ForgotPassword from './ForgotPassword';
import { AuthPersist } from '../../../../store/ducks/authPersist';
import { AuthSession } from '../../../../store/ducks/auth';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';
import { Permissao, APIHelper } from '../../../../shared/helpers';
import * as CodEmpresaConst from '../../../../shared/const/CodEmpresaConst';
import AccessibilityBar from '../../../consulta-acessibilidade/AccessibilityBar';
import AccessibilityContextProvider from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import { changeLogoById } from '../../../../store/ducks/pageConfig';
import * as TipoAutenticacaoInstitucional from '../../../../shared/const/TipoAutenticacaoInstitucional';
import { useAppMobileContext } from '../../../../shared/contexts/AppMobileCommunicationContext';
import { usePrefiterParams } from '../../../../shared/hooks';
import { StyleHelper } from '../../../../shared/helpers/StyleHelper';
import { sanitizeImageUrl } from '../../../../shared/utils/urlSanitizer';

const modeLogin = 'LOGIN';
const modeForgotPassword = 'FORGOT_PASSWORD';

const normalizeDestinoLogin = value => {
    const destino = String(value ?? '').trim().toUpperCase();
    return ['M', 'C'].includes(destino) ? destino : '';
};

const Login = props => {
    const {
        embedded,
        modal,
        openModalRender,
        altRender,
        loginCallback,
        credentials,
        acessibilidadeRx,
        instituicao,
        labelAcessarAlternativo,
        msgErroCustom,
        renderByAccessibilitySearch,
        logoById,
        instituicaoRx
    } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const urlSearch = new URLSearchParams(window.location.search);
    const redirectQuery = queryString.parseUrl(window.location.href).query.redirect;
    const normalizedRedirectQuery = redirectQuery && String(redirectQuery).trim().length
        ? String(redirectQuery).trim()
        : '';
    const redirectUrl = normalizedRedirectQuery
        ? (normalizedRedirectQuery.startsWith('/') ? normalizedRedirectQuery : `/${normalizedRedirectQuery}`)
        : '/';
    const hideBackButton = redirectUrl === '/alerta-bibliografico';
    const hasRedirectQuery = !!normalizedRedirectQuery && normalizedRedirectQuery !== '/';
    const destination = urlSearch.get('destination');
    const flag = new URLSearchParams(window.location.search).get('redirect');
    const bases = [
        'pearson',
        'cengage',
        'editora_forum',
        'minhabiblioteca',
        'minhabiblioteca_med',
        'ebrary',
        'rtonline',
        'lectio',
        'gale',
        'gale_book',
        'oxford',
        'proquest',
        'uptodate',
        'lexicomp',
        'solucto',
        'jornalderesenhas',
        'vlex',
        'elivro',
        'trab_aca',
    ];

    const isBaseRedirect = bases.includes(flag)
    const { t } = useTranslation();
    const { getAll } = usePrefiterParams();
    const destinoLoginInicial = normalizeDestinoLogin(
        destination && ['M', 'C'].includes(destination)
            ? destination
            : (isBaseRedirect ? 'C' : instituicao.destino_padrao_login_catalogo)
    );
    const [loginData, setLoginData] = useState({
        username: '',
        password: '',
        recaptchaToken: false,
        rememberMe: false,
        pwVisibility: false,
        destinoLogin: destinoLoginInicial,
    });
    const [error, setError] = useState(sessionStorage.getItem("oidc_msg_erro") != null ? t(sessionStorage.getItem("oidc_msg_erro")) : false);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [formMode, setFormMode] = useState(modeLogin);
    const [isMsgLoginCollapsed, setMsgLoginCollapsed] = useState(false);
    const [chooseLogin, setChooseLogin] = useState(false);
    const [loginsPessoa, setLoginsPessoa] = useState([]);
    const [bloquearCampoUsuario, setBloquearCampoUsuario] = useState(false);
    // Usado para customização da SÃO CAMILO, que pede somente usuário e depois pede a senha
	const [mostrarCamposSenhaEComplementos, setMostrarCamposSenhaEComplementos] = useState(instituicao.codEmpresa !== CodEmpresaConst.SAO_CAMILO);
    const [pessoasDuplicadas, setPessoasDuplicadas] = useState([]);
    const [codPessoaDuplicadaSelecionada, setCodPessoaDuplicadaSelecionada] = useState(false);
    const [categoria, setCategoria] = useState("01");
    const recaptchaInstance = useRef();
    const usaRecaptcha = Permissao.tem(1120);
    const recaptchaId = Math.floor(Math.random() * 100);
    const obrigaLoginModal = !Permissao.tem(107); // A permissão desabilita obrigatoriedade de login da modal se já estiver logado
    const possuiMeuPergamum = Permissao.tem(8);
    const permissaoMeuPergamum = Permissao.busca(8);
    const possuiSelecaoDestino = !embedded && !modal && possuiMeuPergamum && !hasRedirectQuery; // Só pergunta o destino quando não há redirect explícito na URL
    const permissaoMostraEsqueciSenha = Permissao.busca(1113);
    const collapseAlertRef = useRef(null);
    const usaSaml = process.env.REACT_APP_USA_SAML ? process.env.REACT_APP_USA_SAML === "true" : false;
    const usaOAuth = instituicao.hasOwnProperty("usaOAuth") ? instituicao.usaOAuth : false;
    const paramSuporte = new URLSearchParams(window.location.search).get('suporte') === "true";
    const usaLoginInstitucional = (usaSaml || usaOAuth) && !paramSuporte;
    const tipoAutenticacaoInstitucional = instituicao.hasOwnProperty("tipoAutenticacaoInstitucional") ?
        instituicao.tipoAutenticacaoInstitucional : TipoAutenticacaoInstitucional.SELECAO_INSTITUCIONAL_PERGAMUM;
    // Controla exibição de todo o formulário de login do Pergamum (não institucional)
    const [mostrarCamposLoginPergamum, setMostrarCamposLoginPergamum] = useState(!usaLoginInstitucional);
    const toRestrictedAccess = new URLSearchParams(window.location.search).get('origin') === 'restricted_access';
    const [textoEsqueciSenha, setTextoEsqueciSenha] = useState(null);
    useEffect(() => {
        if (usaLoginInstitucional && tipoAutenticacaoInstitucional === TipoAutenticacaoInstitucional.SOMENTE_INSTITUCIONAL) {
            if (!embedded && !modal) {
                acessarLoginInstitucional();
            }
        }
    }, []);

    useEffect(() => {

        if(collapseAlertRef?.current){
            const messageInternationalization = t('VerMais')
            collapseAlertRef?.current?.style?.setProperty('--see-more-message', `"${messageInternationalization}"`);
        }

        function handleClickOutside(event) {
            if (collapseAlertRef.current && !collapseAlertRef.current.contains(event.target)) {
                collapseAlertRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                setMsgLoginCollapsed(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [collapseAlertRef]);

    const { setOnGoBackMobile, setMobileView, lang } = useAppContext()


    useEffect(() => {
        setOnGoBackMobile(() => {
            return () => {
                setMobileView(null);
                navigate(-1);
            }
        })

        return () => {
            setOnGoBackMobile(null)
        }
    }, [setOnGoBackMobile]);

    const { renderedByApp, sendUserDataToApp, sendLogToApp } = useAppMobileContext()
    sessionStorage.removeItem("oidc_msg_erro"); //Remove pois se existia já foi setado no state de erro

    // Buscar texto informativo personalizado para atividade 1113 (Esqueci Senha)
    useEffect(() => {
        setTextoEsqueciSenha(null);
        ParametrosAPI.buscaMensagemInformativaPorAtividade(1113)
            .then(response => {
                if (response.data && response.data.textoInformativo) {
                    setTextoEsqueciSenha(response.data.textoInformativo);
                }
            })
            .catch(error => {
                // Se houver erro, mantém o texto padrão da tradução

            });
    }, [lang]);

    const getRedirectUrlLogin = () => {
        const destinoLoginSelecionado = normalizeDestinoLogin(loginData.destinoLogin);

        //Se não possui campo para selecionar destino, redireciona para o redirect normal
        if(!renderedByApp && !possuiSelecaoDestino)
            return redirectUrl;

        //Redirecionar para Meu Pergamum
        if(destinoLoginSelecionado === 'M')
            return "/meupergamum";

        //Aqui o redirecionamento é para o catálogo
        const destino = redirectUrl === "/meupergamum" ? "/" : redirectUrl;
        MyPergamumAPI.saveLog('apenas_login')


        return destino;
    }

    const getRedirectSamlOIDC = () => {
        let redirect = getRedirectUrlLogin();

        //Se não for a página de login, então direciona para o path da página atual após login
        if(embedded || modal)
            redirect = window.location.pathname + window.location.search;

        return redirect;
    }

    const getTextoEsqueciSenha = () => {
        return textoEsqueciSenha || t('EsqueciSenha');
    }

    const acessarLoginInstitucional = () => {
        const destinoLoginSelecionado = normalizeDestinoLogin(loginData.destinoLogin);

        if(!renderedByApp && possuiSelecaoDestino){
            if (!destinoLoginSelecionado.length) {
                setError(t('PreenchaCampo', { campo: t("DirecionarPara") }));
                setLoginData(ld => ({ ...ld, recaptchaToken: false }));
                recaptchaInstance?.current?.reset();
                return;
            }
        }

        if (usaOAuth) {
            acessarOAuth();
            return;
        }
        if (usaSaml) {
            acessarSaml();
        }
    }

    const acessarOAuth = () => {
        setLoading(true);
        setError(false);

        const redirectOIDC = getRedirectSamlOIDC();

        AuthAPI.gerarAutenticacaoOIDC(
            '',
            redirectOIDC
        ).then(response => {
            setError(false);
            localStorage.setItem("oidc_sessao_nonce", response.data.nonce)
            window.open(response.data.link, '_self');
        }).catch(err => tratarErroApiLogin(err));
    }

    const acessarSaml = () => {
        setLoading(true);
        setError(false);

        const redirectSaml = getRedirectSamlOIDC();

        AuthAPI.gerarAutenticacaoSaml(
            redirectSaml
        ).then(response => {
            setError(false);
            window.open(response.data.link, '_self');
        }).catch(err => tratarErroApiLogin(err));
    }

    useEffect(() => {
        const { id } = getAll();
        if(id && logoById === null){
            ResourcesAPI.getLogoById(id).then(response => {
                if(response && response?.data){
                    Store.dispatch(changeLogoById(response.data))
                }
            }).catch((error) => {

            })
        }
    }, [logoById]);


    const doLogin = () => {
        const destinoLoginSelecionado = normalizeDestinoLogin(loginData.destinoLogin);

        if(!renderedByApp && possuiSelecaoDestino){
            if (!destinoLoginSelecionado.length) {
                setError(t('PreenchaCampo', { campo: t("DirecionarPara") }));
                setLoginData(ld => ({ ...ld, recaptchaToken: false }));
                recaptchaInstance.current?.reset();
                return;
            }
        }

        if (!loginData.username.trim().length) {
            setError(t(`credential_missing`));
            setLoginData(ld => ({ ...ld, recaptchaToken: false }));
            recaptchaInstance.current?.reset();
            return;
        }

        if(mostrarCamposSenhaEComplementos){
            if(instituicao.codEmpresa === CodEmpresaConst.SAO_CAMILO &&
                pessoasDuplicadas &&
                pessoasDuplicadas.length > 0 &&
                !codPessoaDuplicadaSelecionada){
                setError(t('PreenchaCampo', { campo: t("EscolhaLogin") }));
                setLoginData(ld => ({ ...ld, recaptchaToken: false }));
                recaptchaInstance.current?.reset();
                return;
            }

            //se for usiminas manda sem a senha
            if (!loginData.password.trim().length) {
                setError(t(`credential_missing`));
                setLoginData(ld => ({ ...ld, recaptchaToken: false }));
                recaptchaInstance.current?.reset();
                return;
            }

            if (
                !loginData.recaptchaToken &&
                usaRecaptcha &&
                process.env.MIX_APP_RECAPTCHA_SITEKEY
            ) {
                setError(t('fill_captcha'));
                return;
            }
        }

        setLoading(true);
        setError(false);

        //Se é São Camilo e não mostrarCamposSenhaEComplementos, precisa validar quantas pessoas existem para decidir se vai mostrar combo de usuário ou não
        if(instituicao.codEmpresa === CodEmpresaConst.SAO_CAMILO && !mostrarCamposSenhaEComplementos){
            setCodPessoaDuplicadaSelecionada(false);

            PessoaAPI.buscarPessoasDuplicadas(loginData.username)
                .then(response => {
                    setLoading(false);

                    const retorno = response.data;

                    //Possui duplicidade
                    if(retorno.result){
                        setPessoasDuplicadas(retorno.pessoas);
                    } else {
                        setPessoasDuplicadas([]);
                    }

                    setBloquearCampoUsuario(true);
                    setMostrarCamposSenhaEComplementos(true);
                }).catch(err => APIHelper.tratarErro(err));

            return;
        }

        let { username } = loginData;
        //Se é São Camilo e tem pessoa selecionada, mudar username
        if(instituicao.codEmpresa === CodEmpresaConst.SAO_CAMILO && codPessoaDuplicadaSelecionada)
            username = `${username}@PERG@${codPessoaDuplicadaSelecionada}`;

        //Unisc envia a categoria
        if(instituicao.codEmpresa === CodEmpresaConst.UNISC)
            username = `${username}@PERG@${categoria}`;

        //UFPEL envia um codigo de categoria interno deles - não se trata do código da categ_usuario.
        if (instituicao.codEmpresa === CodEmpresaConst.UFPEL)
            username = `${categoria}${username}`;

        // ? Busca o token de login
        AuthAPI.login(
            username,
            loginData.password,
            usaRecaptcha ? loginData.recaptchaToken : false,
        )
        .then(response => {
            setError(false);
            return {
                credentials: {
                    token: response.data.access_token,
                    refresh: response.data.refresh_token,
                },
            };
        })
        .then(authToken => {
            // ? Busca os dados do usuário com o token de login retornado
            return AuthAPI.getUserData(authToken).then(response => {
                if (response.data.bloqueio) {
                    return Promise.reject({ response: { status: 430 } });
                }

                const userData = {
                    ...response.data.user,
                    login: loginData.username.trim(),
                };

                localStorage.setItem('msg_shwnd', 1);
                return {
                    ...authToken,
                    user: userData,
                    authPermissions: response.data.authPermissions,
                };
            });
        })
            .then( authData => {
                if(renderedByApp){
                    if(authData.user?.app_uuid === null){
                        return PessoaAPI.generateAppUUId(authData.credentials.token).then((response) => {
                            const { data } = response
                            if(data){
                                const { app_uuid } = data;
                                authData.user.app_uuid = app_uuid;
                            }
                            return authData;
                        }).catch((error) => {
                            sendLogToApp(`Error on store app uuid -> ${error}`)
                            return authData
                        })
                    }
                }
                return authData;
            })
        .then(finalAuth => {
            // ? Chama o reducer correto (localstorage ou sessionstorage)
            if (loginData.rememberMe) {
                Store.dispatch(AuthPersist.storeData(finalAuth));
                Store.dispatch(AuthPersist.storeAtvLang(lang))
            } else {
                Store.dispatch(AuthSession.storeData(finalAuth));
                Store.dispatch(AuthSession.storeAtvLang(lang))
            }
            if (loginCallback) {
                //Limpa o campo de senha antes de acionar o callback para que senha não fique exposta na tela
                setLoginData(ld => ({
                    ...ld,
                    password: '',
                }));

                loginCallback(finalAuth.user);
            }
            setLoading(false);
            // ? Se estiver na tela de login, redireciona
            if (!embedded && !modal) {
                // ? Busca logins da pessoa
                PessoaAPI.buscarLoginsPessoa()
                    .then(response => {
                        if (
                            response.data.length &&
                            response.data.length > 1
                        ) {
                            setLoginsPessoa(response.data);
                            return setChooseLogin(true);
                        }
                        if (bases.includes(flag)) {
                            return PessoaAPI.geraUrlAcessoBase(flag)
                                .then(response => {
                                    window.open(
                                        response.data.url,
                                        '_blank',
                                    )
                                    navigate('/')
                                })
                                .catch(err => APIHelper.tratarErro(err));
                        }
                        const modoMeuPergamum = Number(
                            process.env.REACT_APP_MEU_PERGAMUM_MODE,
                        );
                        if (modoMeuPergamum === 0) {
                            return PessoaAPI.geraUrlAcessoMeuPergamum()
                                .then(
                                    response =>
                                        window.open(
                                            response.data.url,
                                            '_blank',
                                        ) && navigate(getRedirectUrlLogin()),
                                )
                                .catch(err => APIHelper.tratarErro(err));
                        }
                        navigate(getRedirectUrlLogin());
                    })
                    .catch(err => APIHelper.tratarErro(err));

                if(renderedByApp){
                    sendUserDataToApp({
                        app_uuid: finalAuth.user.app_uuid,
                        name: finalAuth.user.nome_pessoa
                    })
                }
            }
            if (modal) {
                setModalOpen(false);

                if (obrigaLoginModal) {
                    setLoginData(ld => ({
                        ...ld,
                        username: '',
                        password: '',
                        recaptchaToken: false,
                    }));

                    window.setTimeout(() => {
                        Store.dispatch(AuthPersist.logout());
                        Store.dispatch(AuthSession.logout());
                    }, 1000);
                }
            }
        })
        .catch(err => tratarErroApiLogin(err));
    };

    const tratarErroApiLogin = err => {
        console.error('err.login', err);

        setLoading(false);
        setLoginData(ld => ({
            ...ld,
            password: '',
            recaptchaToken: false,
        }));

        if (recaptchaInstance.current) {
            recaptchaInstance.current.reset();
        }

        let errorAux = 500;

        if (err.response?.status === 422 || err.response?.status === 400) {
            console.log(err.response)
            errorAux = err.response?.data?.message || 'Erro de validação';
        } else if (err.response?.status === 401) {
            errorAux = msgErroCustom
                ? msgErroCustom
                : t('UsuarioOuSenhaIncorretaCustom', {
                    usuario: instituicao.denominacao_login
                        ? instituicao.denominacao_login
                        : t('Usuario'),
                });
        } else if (err.response?.data?.message === 'ACESSO_BLOQUEADO') {
            errorAux = 430;
        } else if (err.response?.status) {
            errorAux = err.response.status;
        }

        setError(errorAux);
    };

    const handleChangeLoginForm = e => {
        const { value, name } = e.target;
        const loginDataAux = { ...loginData };
        loginDataAux[name] = value;
        setLoginData(loginDataAux);
    };

    const getBaseTrocaPessoa = () => {
        const destinoLoginSelecionado = normalizeDestinoLogin(loginData.destinoLogin);

        if (bases.includes(flag)) {
            return flag;
        }

        if (destinoLoginSelecionado === 'M' || redirectUrl.startsWith('/meupergamum')) {
            return '/meupergamum';
        }

        return '/';
    };

    const handleSelectCombo = value => {
        PessoaAPI.trocarPessoa(value, getBaseTrocaPessoa())
            .then(response => {
                if (response?.data?.url) {
                    window.open(response.data.url, '_self');
                    return;
                }

                navigate(getRedirectUrlLogin());
            })
            .catch(err => APIHelper.tratarErro(err));
    };

    const recaptchaCallback = args => {
        setLoginData(ld => ({ ...ld, recaptchaToken: args }));
    };

    const altRenderParentStyle = {};

    if (renderByAccessibilitySearch) {
        altRenderParentStyle.width = '100%';
    }

    const getConditionalFormGroup = () => {
        if([CodEmpresaConst.UNISC, CodEmpresaConst.UFPEL].includes(instituicao.codEmpresa)){
            return (
                <FormGroup>
                    <div>
                        <Label className="f900 s12 preto80 mb-0">
                            {t("Categoria")}
                        </Label>
                        <div>
                            <FontAwesomeIcon
                                icon="bookmark"
                                className="fa-fw cortxt r5 l5 s20 float-left t5 cortxt"
                            />
                            <div>
                                <Input
                                    type="select"
                                    className="rad10 b-tema20 cortxt form-control"
                                    value={categoria}
                                    onChange={e => setCategoria(e.target.value)}
                                    style={{ width: 'calc( 100% - 54px)' }}
                                >
                                    {
                                        instituicao.codEmpresa === CodEmpresaConst.UNISC ? (
                                            <>
                                                <option value="01">{`${t('AlunoGraduacao')} / ${t('Especiais')}`}</option>
                                                <option value="19">{t('AlunoGraduacaoDigital')}</option>
                                                <option value="03">{`${t('AlunoPosGraduacao')} / ${t('Especiais')}`}</option>
                                                <option value="06">{t('AlunoEducarse')}</option>
                                                <option value="07">{t('AlunosIdiomasUniamaAgricola')}</option>
                                                <option value="21">{t('CursoTecnicoNivelMedio')}</option>
                                                <option value="09">{t('Doutorado')}</option> /
                                                <option value="05">{t('Funcionario')}</option>
                                                <option value="12">{t('FuncionarioHospital')}</option>
                                                <option value="Intercamb">{t('Intercambista')}</option>
                                                <option value="MembroComun">{t('MembroComunidadeVoltare')}</option>
                                                <option value="08">{t('Mestrado')}</option>
                                                <option value="04">{t('Professor')}</option>
                                                <option value="10">{t('UsuarioEspecial')}</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="01">{t('AlunoGraduacao')}</option>
                                                <option value="04">{t('AlunoPosGraduacao')}</option>
                                                <option value="030">{t('Servidor')}</option>
                                                <option value="">{t('Outros')}</option>
                                            </>
                                        )
                                    }

                                </Input>
                            </div>
                        </div>
                    </div>
                </FormGroup>
            )
        }

        return null;
    }

    const LoginForm = (
        <Form onSubmit={(e) => {
            e.preventDefault();
            doLogin();
        }}>
            {!loading && !chooseLogin ? (<div style={altRenderParentStyle}>

                {/* Se não estiver embutido, não for modal e possuir meu pergamum, pergunta qual o destino do login */}
                {possuiSelecaoDestino && !renderedByApp && !toRestrictedAccess && !isBaseRedirect &&
                    <FormGroup>
                        <Row>
                            <Col md="12">
                                <Label className="f900 s12 preto80 l30">
                                    {t('DirecionarPara')}
                                </Label>
                            </Col>
                            <Col md="12" className="d-flex">
                                <FontAwesomeIcon
                                    icon="map-signs"
                                    className="fa-fw cortxt r5 s20 float-left t5 cortxt"
                                />

                                <Input
                                    type="select"
                                    className="b-tema20 cortxt rad10 s14"
                                    value={loginData.destinoLogin}
                                    onChange={e => setLoginData(ld => ({
                                        ...ld,
                                        destinoLogin: e.target.value,
                                    }))}
                                >
                                    <option disabled value="">
                                        {t("SelecioneOpcao")}
                                    </option>
                                    <option value="M">
                                        {permissaoMeuPergamum.descricao}
                                    </option>
                                    <option key="destino-c" value="C">
                                        {t("CatalogoOnline")}
                                    </option>
                                </Input>
                            </Col>
                        </Row>
                    </FormGroup>
                }

                {/* Login institucional ou Login Pergamum */}
                {usaLoginInstitucional && <>
                    <Row className="mt-3">
                        <Col md="12">
                            <Button
                                onClick={() => acessarLoginInstitucional()}
                                className="w-100 bkverde branco b-none sverde hover hpreto p-3 rad5 t10 r10 f770 s16"
                                disabled={loading || chooseLogin}
                            >
                                <FontAwesomeIcon icon="external-link-alt" className="r5" />
                                {t('AcessarLoginInstitucional', {siglaInstituicao: instituicao.sigla})}
                            </Button>
                        </Col>
                    </Row>
                    {tipoAutenticacaoInstitucional === TipoAutenticacaoInstitucional.SELECAO_INSTITUCIONAL_PERGAMUM && <>
                        <Row className="mt-3">
                            <Col md="5">
                                <hr />
                            </Col>
                            <Col md="2" className="text-center">
                                {t("OR").toUpperCase()}
                            </Col>
                            <Col md="5">
                                <hr />
                            </Col>
                        </Row>
                        <Row className="my-3">
                            <Col md="12">
                                <Button
                                    onClick={() => setMostrarCamposLoginPergamum(!mostrarCamposLoginPergamum)}
                                    className="w-100 bkcinza2 preto b-none hover hpreto p-3 rad5 r10 f770 s16"
                                    disabled={loading || chooseLogin}
                                >
                                    <FontAwesomeIcon icon="sign-in-alt" className="r5" />
                                    {t('AcessarLoginPergamum')}
                                </Button>
                            </Col>
                        </Row>
                    </>}
                </>}
                {/* .Login institucional ou Login Pergamum */}

                {/* Mensagem de erro */}
                {error && (
                    <Alert
                        color={error === 500 ? 'danger' : 'warning'}
                        isOpen={error !== false}
                        className="mt-2 position-relative pr-5"
                    >
                        <button
                            type="button"
                            onClick={() => setError(false)}
                            aria-label="Fechar"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                padding: 0,
                                marginRight: '10px',
                                cursor: 'pointer',
                                fontSize: '20px',
                                lineHeight: 1,
                                color: 'inherit',
                            }}
                        >
                            ×
                        </button>

                        {typeof error === 'string' ? error : t(`${error}`)}
                    </Alert>
                )}
                {/* .Mensagem de erro */}

                {/* .Campos login Pergamum */}
                {mostrarCamposLoginPergamum && <>
                    <FormGroup>
                        {embedded && altRender && !modal && (
                            <div>{altRender(!!credentials)}</div>
                        )}
                        {instituicao.msg_login && instituicao.msg_login.length && (
                            <div
                                ref={collapseAlertRef}
                                className={classnames('alert alert-info mt-2 click' , {
                                    'text-truncate': !isMsgLoginCollapsed,
                                    'login-message-collapsed' : !isMsgLoginCollapsed
                                })}
                                onClick={() => {
                                    if(isMsgLoginCollapsed) {
                                        collapseAlertRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                                    }
                                    setMsgLoginCollapsed(!isMsgLoginCollapsed)
                                }}
                                style={{
                                    maxHeight: 200,
                                    overflowY: isMsgLoginCollapsed ? 'auto' : 'hidden',
                                }}
                                dangerouslySetInnerHTML={createSanitizedInnerHTML(instituicao.msg_login)}
                            />
                        )}

                        {/* Customização UNISC e UFPEL */}
                        {getConditionalFormGroup()}
                        {/* .Customização UNISC e UFPEL */}

                        <Label for="username" className="f900 s12 preto80 mb-0">
                            {instituicao.denominacao_login ? instituicao.denominacao_login : t('Usuario')}
                        </Label>
                        {bloquearCampoUsuario ?
                            <div className='d-flex align-items-center'>
                                <button
                                    type="button"
                                    className="btn-generic--segundo px-2 ml-0"
                                    onClick={() => {
                                        setBloquearCampoUsuario(false);
                                        setMostrarCamposSenhaEComplementos(false);
                                        loginData.password = '';
                                    }}
                                >
                                    <FontAwesomeIcon icon='arrow-left' className='fa-fw'/>
                                </button>
                                <span className='preto70 s16 f500 ml-2'>{loginData.username}</span>
                            </div>
                            :
                            <div style={{ display: 'flex' }}>

                                <Input
                                    name="username"
                                    id="username"
                                    className="rad10 b-tema20 cortxt form-control"
                                    onChange={e => handleChangeLoginForm(e)}
                                    value={loginData.username}
                                    style={{ width: 'calc( 100% - 54px)' }}
                                    disabled={loading}
                                />
                            </div>
                        }
                    </FormGroup>

                    {/* Customização de seleção de pessoa */}
                    {mostrarCamposSenhaEComplementos &&
                        instituicao.codEmpresa === CodEmpresaConst.SAO_CAMILO &&
                        pessoasDuplicadas &&
                        pessoasDuplicadas.length > 0 &&
                        <FormGroup>
                            <Label for="selecaoPessoa" className="f900 s12 preto80 mb-0">
                                {t('EscolhaLogin')}
                            </Label>
                            <div style={{ display: 'flex' }}>
                                <Input
                                    name="selecaoPessoa"
                                    id="selecaoPessoa"
                                    type="select"
                                    className="rad10 b-tema20 cortxt form-control"
                                    value={codPessoaDuplicadaSelecionada}
                                    onChange={e => setCodPessoaDuplicadaSelecionada(e.target.value)}
                                    style={{ width: 'calc( 100% - 54px)' }}
                                >
                                    <option disabled value={false}>
                                        {t("SelecioneOpcao")}
                                    </option>
                                    {pessoasDuplicadas.map(p =>
                                        <option
                                            key={`pessoa-selecao-${p.codigo}`}
                                            value={p.codigo}
                                        >
                                            {p.nome}
                                        </option>
                                    )}
                                </Input>
                            </div>
                        </FormGroup>
                    }

                    {mostrarCamposSenhaEComplementos ? (
                        <FormGroup>
                            <Label for="password" className="f900 s12 preto80 mb-0">
                                {t('Senha')}
                            </Label>
                            <div style={{ display: 'flex' }}>
                                <Input
                                    name="password"
                                    id="password"
                                    className="rad10 b-tema20 cortxt form-control"
                                    type={
                                        loginData.pwVisibility ? 'text' : 'password'
                                    }
                                    onChange={e => handleChangeLoginForm(e)}
                                    value={loginData.password}
                                    style={{ width: 'calc( 100% - 54px)' }}
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="btn-generic--segundo px-2"
                                    onClick={() =>
                                        setLoginData(ld => ({
                                            ...ld,
                                            pwVisibility: !loginData.pwVisibility,
                                        }))
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            loginData.pwVisibility
                                                ? 'eye'
                                                : 'eye-slash'
                                        }
                                    />
                                </button>
                            </div>
                        </FormGroup>) : null
                    }

                    {usaRecaptcha && process.env.MIX_APP_RECAPTCHA_SITEKEY && mostrarCamposSenhaEComplementos && (
                        <div>
                            <FormGroup>
                                <div
                                    style={{
                                        width: 'calc( 100% - 54px)',
                                        display: 'table',
                                        margin: 'auto'
                                    }}
                                >
                                    <ReCAPTCHA
                                        id={`recaptcha__${recaptchaId}`}
                                        ref={recaptchaInstance}
                                        size={
                                            window.matchMedia(
                                                '(max-width: 575.98px)',
                                            ).matches
                                                ? 'compact'
                                                : 'normal'
                                        }
                                        sitekey={
                                            process.env
                                                .MIX_APP_RECAPTCHA_SITEKEY
                                        }
                                        onChange={recaptchaCallback}
                                        className='pegaCaptcha'
                                    />
                                </div>
                            </FormGroup>
                        </div>
                    )}

                </>}
                {/* .Campos login Pergamum */}

            </div> ) : !chooseLogin ? (
                <div className="text-center animated fadeIn p-3">
                    <SpinnerConstructor
                        visible
                        width={60}
                        height={60}
                        className="s20 cortxt70"
                    />
                    <div className="t20">
                        <span className="preto70 f300 s20">
                            {t('Autenticando')}...
                        </span>
                    </div>
                </div>
            ) : (
                <div>
                    <FormGroup>
                        <div>
                            <Input
                                type="select"
                                name="login_user"
                                className="b-tema20 rad10 s14 cortxt"
                                value="-1"
                                onChange={e =>
                                    handleSelectCombo(e.target.value)
                                }
                            >
                                <option value="-1" disabled>
                                    {t('EscolhaLogin')}
                                </option>
                                {loginsPessoa.map(b => (
                                    <option
                                        key={`bib-orig-${b.codigo}`}
                                        className="preto70"
                                        value={b.codigo}
                                    >
                                        {b.nome}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    </FormGroup>
                </div>
            )}
            <Row className="b10 pt-3 b-w1 b-dotted-top b-cinza">
                <Col md="3" xs="2" />
                <Col md="6" xs="12" className="text-center">
                    {mostrarCamposLoginPergamum &&
                        <Button
                            onClick={() => doLogin()}
                            className="btn-generic--primeiro ml-0 btn-responsivo mb-md-0 mb-3 mr-2"
                            disabled={loading || chooseLogin}
                        >
                            <FontAwesomeIcon icon="sign-in-alt" className="r5" />
                            {mostrarCamposSenhaEComplementos ? (
                                labelAcessarAlternativo || t('Acessar')
                            ) : (
                                t('Avancar')
                            )}
                        </Button>
                    }
                    {!embedded && !modal && !hideBackButton ? (
                        <Button
                            className={classnames('btn-generic--segundo ml-0 btn-responsivo mb-md-0 mb-3', {
                                'l30': mostrarCamposLoginPergamum
                            })}
                            onClick={() => navigate(redirectUrl.startsWith("/meupergamum") ? "/" : redirectUrl)} >
                            <FontAwesomeIcon
                                icon="chevron-left"
                                className="r5"
                            />
                            {t('Voltar')}
                        </Button>
                    ) : null}
                </Col>
                <Col md="3" xs="2" />
            </Row>
        </Form>
    );

    const getContent = () => {
        switch (formMode) {
            case modeLogin:
                return LoginForm;
            case modeForgotPassword:
                return (
                        <ForgotPassword
                            changeModeCallback={() => setFormMode(modeLogin)}
                            embedded={embedded}
                            usaRecaptcha={usaRecaptcha}
                        />
                    )
            default:
                return null;
        }
    };

    if (embedded) {
        return credentials ? (
            altRender(true)
        ) : (
            <div>
                <Row>
                    <Col md="12" xs="12">
                        {getContent()}
                    </Col>
                    {instituicao &&
                        instituicao.p.__md_aut === '2' &&
                        instituicao.p.__md_crypt === '4' && (
                            <Col
                                md="12"
                                xs="12"
                                className="text-center pt-2 pb-2"
                            >
                                {formMode === modeLogin && (
                                    <span
                                        className="pad5 s13 rad5 hover hpreto f500 link preto80 bkbranco click"
                                        onClick={() =>
                                            setFormMode(modeForgotPassword)
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon="question-circle"
                                            className="r5"
                                        />
                                        {getTextoEsqueciSenha()}
                                    </span>
                                )}
                                {formMode === modeForgotPassword && (
                                    <span
                                        className="pad5 s13 rad5 hover hpreto f500 link preto80 bkbranco click"
                                        onClick={() => setFormMode(modeLogin)}
                                    >
                                        <FontAwesomeIcon
                                            icon="angle-left"
                                            className="r5"
                                        />
                                        {t('Voltar')}
                                    </span>
                                )}
                            </Col>
                        )}
                </Row>
            </div>
        );
    }
    if (modal) {
        return (
            <div style={altRenderParentStyle}>
                <ModalConstructor
                    closeable
                    open={modalOpen}
                    title={t('Acesso')}
                    size="xs"
                    setOpen={setModalOpen}
                >
                    <Row>
                        <Col md="12" xs="12">
                            {getContent()}
                        </Col>
                        {instituicao &&
                            instituicao.p.__md_aut === '2' &&
                            instituicao.p.__md_crypt === '4' && (
                                <Col
                                    md="12"
                                    xs="12"
                                    className="text-center pt-2 pb-2"
                                >
                                    {formMode === modeLogin && (
                                        <span
                                            className="pad5 s13 rad5 hover hpreto f500 link preto80 bkbranco click"
                                            onClick={() =>
                                                setFormMode(modeForgotPassword)
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon="question-circle"
                                                className="r5"
                                            />
                                            {getTextoEsqueciSenha()}
                                        </span>
                                    )}
                                    {formMode === modeForgotPassword && (
                                        <span
                                            className="pad5 s13 rad5 hover hpreto f500 link preto80 bkbranco click"
                                            onClick={() =>
                                                setFormMode(modeLogin)
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon="angle-left"
                                                className="r5"
                                            />
                                            {t('Voltar')}
                                        </span>
                                    )}
                                </Col>
                            )}
                    </Row>
                </ModalConstructor>
                {altRender(!!credentials && !obrigaLoginModal)}
                {(!credentials || obrigaLoginModal) &&
                    (!openModalRender ? (
                        <button
                            type="button"
                            className="pad10 rad5 sombra b-tema b-w1 bkzero cortxt s15 hover hpreto"
                            onClick={() => setModalOpen(!modalOpen)}
                        >
                            <FontAwesomeIcon
                                icon="user-circle"
                                className="r5"
                            />
                            {t('RealizarLogin')}
                        </button>
                    ) : (
                        <div
                            onClick={() => setModalOpen(!modalOpen)}
                            className="d-inline-block"
                        >
                            {openModalRender()}
                        </div>
                    ))}
            </div>
        );
    }

    return (
        <Scrollbars autoHeight universal autoHeightMin="100vh">
            <div
                className={[
                    'app acessibilidade',
                    acessibilidadeRx.cor === 'contraste'
                        ? 'temaAltoContraste alto-contraste'
                        : 'tema-pergamum',
                    acessibilidadeRx.zoom
                        ? `zoom-${acessibilidadeRx.zoom}`
                        : null,
                    acessibilidadeRx.negrito ? 'negrito' : null,
                    acessibilidadeRx.cor,
                ].join(' ')}
            >
                {!renderedByApp && !embedded && !modal ? (
                    <AccessibilityContextProvider>
                        <AccessibilityBar />
                    </AccessibilityContextProvider>
                ) : null}
                <div
                    className="imgMeuPergamum bktema"
                    style={{
                        backgroundImage: `url(${process.env.REACT_APP_URL}/imagens/background)`,
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                    }}
                >
                    <Row className="b-w1 b-solid-bottom b-branco">
                        <Col
                            lg="7"
                            md="7"
                            xs="12"
                            className="pad0 d-none d-md-block h-MeuPergamum"
                        >
                            <Row className="b-w2 b-solid-top b-tema t100">
                                <Col
                                    md="5"
                                    className="text-right  pad10"
                                    style={{
                                        backgroundColor: logoById !== null ? `rgba(${logoById.logo_consulta_cor_fundo}, ${logoById?.logo_consulta_opacidade ?? 1}%)` : StyleHelper.getColor(instituicaoRx?.cor_fundo_logotipo_consulta, instituicaoRx?.logotipo_consulta_opacidade ?? 1),
                                    }}
                                >
                                    <Link to="/">
                                        <img
                                            src={sanitizeImageUrl(
                                                logoById !== null ? `${process.env.REACT_APP_URL}${logoById.logo_consulta}` : `${process.env.REACT_APP_URL}/imagens/logo`
                                            )}
                                            style={{
                                                maxHeight: 100
                                        }}
                                            alt="Logotipo"
                                        />
                                    </Link>
                                </Col>
                                <Col
                                    md="7"
                                    className="s30 f100 brancoPuro bkdark80Puro pad20"
                                >
                                    <div className="s13 f900">
                                        {t('SejaBemVindo')}
                                    </div>
                                    {t('CatalogoOnline')}
                                </Col>
                            </Row>
                        </Col>
                        <Col
                            lg="5"
                            md="5"
                            xs="12"
                            className=" bkdark70_0 pad20"
                        >
                            <div
                                className="bktema pad10 rad5 brancoPuro stema s16 f700 bkmontanha"
                                style={{
                                    margin: '0px 30px -15px 30px',
                                    position: 'relative',
                                }}
                            >
                                <FontAwesomeIcon
                                    icon="sign-in-alt"
                                    className="l10 r10"
                                />
                                {t('Acesso')}
                            </div>
                            <div className="bkbranco sombra rad10 pad20">
                                {getContent()}
                            </div>
                            <Row className="s14 t20">
                                {instituicao &&
                                    instituicao.p.__md_aut === '2' &&
                                    instituicao.p.__md_crypt === '4' && (
                                        <Col
                                            md="12"
                                            xs="12"
                                            className="text-center"
                                        >
                                            {formMode === modeLogin && permissaoMostraEsqueciSenha ? (
                                                <span
                                                    className="pad5 rad5 hover hazul f500 link branco bkdark50 click"
                                                    onClick={() =>
                                                        setFormMode(
                                                            modeForgotPassword,
                                                        )
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon="question-circle"
                                                        className="r5"
                                                    />
                                                    {getTextoEsqueciSenha()}
                                                </span>
                                            ): null}
                                            {formMode ===
                                                modeForgotPassword && (
                                                <span
                                                    className="pad5 rad5 hover hazul f500 link branco bkdark50 click"
                                                    onClick={() =>
                                                        setFormMode(modeLogin)
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon="angle-left"
                                                        className="r5"
                                                    />
                                                    {t('Voltar')}
                                                </span>
                                            )}
                                        </Col>
                                    )}
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Footer />
                <ToastContainer
                    autoClose={8000}
                    position="top-center"
                />
            </div>
        </Scrollbars>
    );
};

const mapStateToProps = state => ({
    acessibilidadeRx: state.pageConfig.acessibilidade,
    credentials: state.auth.credentials || state.authPersist.credentials,
    logoById: state.pageConfig.logoById,
    instituicaoRx: state.instituicao.data,
});

Login.propTypes = {
    embedded: PropTypes.bool,
    modal: PropTypes.bool,
    openModalRender: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    altRender: PropTypes.func,
    loginCallback: PropTypes.func,
    labelAcessarAlternativo: PropTypes.string,
    renderByAccessibilitySearch: PropTypes.bool,
};

export default connect(mapStateToProps)(MiddlewareLogin(Login));
